export default "__VITE_ASSET__CuP2oj47__"